interface StayDates {
  checkIn: string;
  checkOut: string;
}

export const haveDatesChanged = (original: StayDates, draft: StayDates) => {
  return original.checkIn !== draft.checkIn || original.checkOut !== draft.checkOut;
};
